import React from 'react';
import { ENV, ENV_ENUM } from '@/shared/config';
import OnlineTimeTracking from './onlineTimeTracking';

/**
 * Enables reviewer online-time tracking only in the environments that collect it. Renders OnlineTimeTracking when the build environment is staging or customer, and renders nothing otherwise.
 *
 * @returns The online time tracker, or false when tracking is off for this environment.
 */
const OnlineTimeTrackingWithCondition = () => {
  const isTrackingEnabled = [ENV_ENUM.staging, ENV_ENUM.customer].includes(ENV);

  return isTrackingEnabled && <OnlineTimeTracking />;
};

export default OnlineTimeTrackingWithCondition;
